import * as React from 'react';
import { formatDateTime } from '@ixicare/ui';
import styles from './OfflineDevice.module.css';

interface OfflineDeviceProps {
  date?: any;
}

const OfflineDevice: React.FC<OfflineDeviceProps> = ({ date }) => {
  return (
    <div>
      {date ? (
        <p className={styles.OfflineDeviceDate}>
          ! <span>{formatDateTime(date)}</span>
        </p>
      ) : (
        <p>undefined</p>
      )}
    </div>
  );
};

export default OfflineDevice;
